// extracted by mini-css-extract-plugin
export default {"wrap":"NotFound_wrap__5aZL6","code":"NotFound_code__0wbq2","title":"NotFound_title__WBMRW","sub":"NotFound_sub__tZCBi","btn":"NotFound_btn__giEu9"};